"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTooltipContainer = exports.StyledPopover = exports.PopoverTitle = exports.PopoverList = exports.PopoverItem = exports.PopoverContent = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _ykbStyledComponents = _interopRequireWildcard(require("../ykb-styled-components"));
var _StyledButton = require("../Button/StyledButton");
var _react = _interopRequireWildcard(require("react"));
var _excluded = ["children", "className", "prefixCls", "error"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var StyledContainer = function StyledContainer(_ref) {
  var children = _ref.children,
    className = _ref.className,
    prefixCls = _ref.prefixCls,
    error = _ref.error,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var prefix = prefixCls ? prefixCls : className.split(' ').pop();
  return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(StyledPopover, (0, _extends2.default)({
    prefixCls: prefix,
    $error: error
  }, rest)), children(prefix));
};
var rcToolTipZoomIn = (0, _ykbStyledComponents.keyframes)(["0%{opacity:0;transform-origin:50% 50%;transform:scale(0,0);}100%{opacity:1;transform-origin:50% 50%;transform:scale(1,1);}"]);
var rcToolTipZoomOut = (0, _ykbStyledComponents.keyframes)(["0%{opacity:1;transform-origin:50% 50%;transform:scale(1,1);}100%{opacity:0;transform-origin:50% 50%;transform:scale(0,0);}"]);
var effect = (0, _ykbStyledComponents.css)(["animation-duration:0.3s;animation-fill-mode:both;"]);
var StyledPopover = exports.StyledPopover = (0, _ykbStyledComponents.createGlobalStyle)([".", "{position:absolute;display:block;top:0;left:0;z-index:", ";visibility:visible;font-size:", ";line-height:", ";opacity:", ";text-align:left;cursor:auto;user-select:text;&:not(.ykb-ui-avatar-popover-overlay){min-width:170px;}&-hidden{display:none;}&-placement-top,&-placement-topLeft,&-placement-topRight{padding:", "px 0 ", "px 0;}&-placement-right,&-placement-rightTop,&-placement-rightBottom{padding:0 ", "px 0 ", "px;}&-placement-bottom,&-placement-bottomLeft,&-placement-bottomRight{padding:", "px 0 ", "px 0;}&-placement-left,&-placement-leftTop,&-placement-leftBottom{padding:0 ", "px 0 ", "px;}&-inner{padding:0;color:", ";text-align:left;text-decoration:none;background-color:", ";border-radius:", ";box-shadow:", ";min-height:34px;}&-arrow{position:absolute;width:0;height:0;border-color:transparent;border-style:solid;}&-placement-top,&-placement-topLeft,&-placement-topRight{[class*='-arrow']{bottom:", "px;margin-left:-", "px;border-width:", "px ", "px 0;border-top-color:", ";}}&-placement-top{[class*='-arrow']{left:50%;}}&-placement-topLeft{[class*='-arrow']{left:15%;}}&-placement-topRight{[class*='-arrow']{right:15%;}}&-placement-right,&-placement-rightTop,&-placement-rightBottom{[class*='-arrow']{left:", "px;margin-top:-", "px;border-width:", "px ", "px ", "px 0;border-right-color:", ";}}&-placement-right{[class*='-arrow']{top:50%;}}&-placement-rightTop{[class*='-arrow']{top:15%;margin-top:0;}}&-placement-rightBottom{[class*='-arrow']{bottom:15%;}}&-placement-left,&-placement-leftTop,&-placement-leftBottom{[class*='-arrow']{right:", "px;margin-top:-", "px;border-width:", "px 0 ", "px ", "px;border-left-color:", ";}}&-placement-left{[class*='-arrow']{top:50%;}}&-placement-leftTop{[class*='-arrow']{top:15%;margin-top:0;}}&-placement-leftBottom{[class*='-arrow']{bottom:15%;}}&-placement-bottom{[class*='-arrow']{top:", "px;margin-left:-", "px;border-width:0 ", "px ", "px;border-bottom-color:", ";}}&-placement-bottomLeft{[class*='-arrow']{top:", "px;margin-left:-", "px;border-width:0 ", "px ", "px;border-bottom-color:", ";}}&-placement-bottomRight{[class*='-arrow']{top:", "px;margin-left:-", "px;border-width:0 ", "px ", "px;border-bottom-color:", ";}}&-placement-bottom{[class*='-arrow']{left:50%;}}&-placement-bottomLeft{[class*='-arrow']{left:15%;}}&-placement-bottomRight{[class*='-arrow']{right:15%;}}&&-zoom-enter,&&-zoom-leave{display:block;}&-zoom-enter,&-zoom-appear{opacity:0;", " animation-timing-function:cubic-bezier(0.18,0.89,0.32,1.28);animation-play-state:paused;}&-zoom-leave{", " animation-timing-function:cubic-bezier(0.6,-0.3,0.74,0.05);animation-play-state:paused;}&-zoom-enter{[class*='-active']{animation-name:", ";animation-play-state:running;}}&-zoom-appear{[class*='-active']{animation-name:", ";animation-play-state:running;}}&-zoom-leave{[class*='-active']{animation-name:", ";animation-play-state:running;}}&-title{min-width:170px;min-height:32px;margin:0;padding:", ";color:", ";font-weight:500;border-bottom:1px solid ", ";}&-inner-content{padding:", ";color:", ";}@media (min-width:480px){max-width:748px;}}"], function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.popover.zIndex;
}, function (props) {
  return props.theme.popover.fontSize;
}, function (props) {
  return props.theme.popover.lineHeight;
}, function (props) {
  return props.theme.popover.opacity;
}, function (props) {
  return props.theme.popover.arrowWidth;
}, function (props) {
  return props.theme.popover.distance;
}, function (props) {
  return props.theme.popover.arrowWidth;
}, function (props) {
  return props.theme.popover.distance;
}, function (props) {
  return props.theme.popover.distance;
}, function (props) {
  return props.theme.popover.arrowWidth;
}, function (props) {
  return props.theme.popover.distance;
}, function (props) {
  return props.theme.popover.arrowWidth;
}, function (props) {
  return props.theme.popover.color;
}, function (props) {
  return props.theme.popover.backgroundColor;
}, function (props) {
  return props.theme.popover.borderRadius;
}, function (props) {
  return props.theme.popover.overlayShadow;
}, function (props) {
  return props.theme.popover.distance - props.theme.popover.arrowWidth;
}, function (props) {
  return props.theme.popover.arrowWidth;
}, function (props) {
  return props.theme.popover.arrowWidth;
}, function (props) {
  return props.theme.popover.arrowWidth;
}, function (props) {
  return props.theme.popover.arrowColor;
}, function (props) {
  return props.theme.popover.distance - props.theme.popover.arrowWidth;
}, function (props) {
  return props.theme.popover.arrowWidth;
}, function (props) {
  return props.theme.popover.arrowWidth;
}, function (props) {
  return props.theme.popover.arrowWidth;
}, function (props) {
  return props.theme.popover.arrowWidth;
}, function (props) {
  return props.theme.popover.arrowColor;
}, function (props) {
  return props.theme.popover.distance - props.theme.popover.arrowWidth;
}, function (props) {
  return props.theme.popover.arrowWidth;
}, function (props) {
  return props.theme.popover.arrowWidth;
}, function (props) {
  return props.theme.popover.arrowWidth;
}, function (props) {
  return props.theme.popover.arrowWidth;
}, function (props) {
  return props.theme.popover.arrowColor;
}, function (props) {
  return props.theme.popover.distance - props.theme.popover.arrowWidth;
}, function (props) {
  return props.theme.popover.arrowWidth;
}, function (props) {
  return props.theme.popover.arrowWidth;
}, function (props) {
  return props.theme.popover.arrowWidth;
}, function (props) {
  return props.theme.popover.arrowColor;
}, function (props) {
  return props.theme.popover.distance - props.theme.popover.arrowWidth;
}, function (props) {
  return props.theme.popover.arrowWidth;
}, function (props) {
  return props.theme.popover.arrowWidth;
}, function (props) {
  return props.theme.popover.arrowWidth;
}, function (props) {
  return props.theme.popover.arrowColor;
}, function (props) {
  return props.theme.popover.distance - props.theme.popover.arrowWidth;
}, function (props) {
  return props.theme.popover.arrowWidth;
}, function (props) {
  return props.theme.popover.arrowWidth;
}, function (props) {
  return props.theme.popover.arrowWidth;
}, function (props) {
  return props.theme.popover.arrowColor;
}, effect, effect, rcToolTipZoomIn, rcToolTipZoomIn, rcToolTipZoomOut, function (props) {
  return props.theme.popover.padding;
}, function (props) {
  return props.theme.popover.color;
}, function (props) {
  return props.theme.popover.borderColor;
}, function (props) {
  return props.theme.popover.padding;
}, function (props) {
  return props.theme.popover.color;
});
var StyledTooltipContainer = exports.StyledTooltipContainer = (0, _ykbStyledComponents.default)(StyledContainer).withConfig({
  componentId: "ykb-ui__sc-12rjzik-0"
})([""]);
var PopoverTitle = exports.PopoverTitle = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-12rjzik-1"
})([""]);
var PopoverContent = exports.PopoverContent = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-12rjzik-2"
})([""]);
var PopoverList = exports.PopoverList = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-12rjzik-3"
})(["padding:4px 0px;"]);
var PopoverItem = exports.PopoverItem = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-12rjzik-4"
})(["padding:8px 15px;font-size:14px;transition:0.1s background;cursor:pointer;:hover{background-color:", ";}&[aria-disabled='true']{cursor:not-allowed;background-color:", ";}"], function (props) {
  return props.theme.colorPalette.grey2;
}, function (props) {
  return props.theme.colorPalette.grey1;
});